define('app-UpdatePassengerTP/settings',[],function () {
    return {
        container: "#portalContainer",

        passengerDetails: "#passengerDetails",
        passengerDetailsUpdate: "#updatePassengerDetails",
        editPassengerDetails: "#btnEditPassengerDetails",
        cancelEditPassengerDetails: "#btnCancelEditPassengerDetails",
        submitPassengerDetails: "#btnSubmitPassengerDetails",

        emergencyContactDetails: "#emergencyContactDetails",
        emergencyContactDetailsUpdate: "#updateEmergencyContactDetails",
        editEmergencyContactDetails: "#btnEditEmergencyContactDetails",
        cancelEditEmergencyContactDetails: "#btnCancelEditEmergencyContactDetails",
        submitEmergencyContactDetails: "#btnSubmitEmergencyContactDetails",

        passportDetails: "#passportDetails",
        passportDetailsUpdate: "#updatePassportDetails",
        editPassportDetails: "#btnEditPassportDetails",
        cancelEditPassportDetails: "#btnCancelEditPassportDetails",
        submitPassportDetails: "#btnSubmitPassportDetails",
        customerFullName: "#Customer_FullName",
        passengerFullNamePlaceholder: ".travelPortal .innerContent h2",
        mobileNumberField: "#PassengerDetailsModel_MobileNo",
        hasMobileNumber: "#PassengerDetailsModel_HasMobileNumber"
};
});
